

import React from "react";
import { MdCircle, MdOutlineKeyboardArrowRight } from "react-icons/md";
import { RxExternalLink } from "react-icons/rx";
import { Link } from "react-router-dom";
import {
    sortDateTime,
    sortPaymentCategory,
    upiIntentLogoDictionary,
} from "../utils/utils";
import HoverToDisplayFullTitle from "../../reusableComponents/HoverToDisplayFullTitle";
import { colorBrandObject } from "../../../constants/brandings";
import { useAuth } from "../../context/API_Client";
import CustomButton from "../../reusableComponents/CustomButton";

const TransactionRenderer = ({ data }) => {
    const transacId = data.transactionId;
    const { isAuthorizedPermission } = useAuth();
    const canViewTransaction = isAuthorizedPermission("VIEW_ORDER_DETAILS") || isAuthorizedPermission("VIEW_OWN_ORDER_DETAILS");

    return (
        <div
            style={{
                display: "flex",
                marginLeft: "-12px",
                alignItems: "center",
                minWidth: "100px",
                paddingRight: "30px",
            }}
        >
            <div
                style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    flex: 1,
                }}
            >
                {transacId && <HoverToDisplayFullTitle title={transacId} len={12} />}
                {canViewTransaction && (
                    <Link
                        id="transaction-all-link"
                        to={
                            "/approvals/detail?transactionId=" + transacId
                        }
                        target="_blank"
                    >
                        <RxExternalLink
                            style={{
                                width: "24px",
                                height: "16px",
                                cursor: "pointer",
                                position: "absolute",
                                right: "0",
                                marginRight: "16px",
                                color: `${colorBrandObject?.actionIconColor}`
                            }}
                        />
                    </Link>
                )}
            </div>

        </div>

    );
};


export const completedWorkflowSchema = (operationPermissions) => {
    const { isAuthorizedPermission } = useAuth;
    return {
        metadata: {
            title: "All Transaction",
            minHeight: 600,
            position: "relative",
            rowHeight: 60,
            showTitle: false,
            defaultSortInfo: { name: "timestamp", dir: -1 },
        },
        fields: [
            {
                name: "transactionId",
                header: "Transaction ID",
                visible: true,
                type: "string",
                filtering: false,
                minWidth: 180,
                defaultFlex: 1,
                textAlign: "center",
                sortable: false,
                render: TransactionRenderer,
            },
            {
                name: "timestamp",
                header: "Created At",
                visible: true,
                type: "string",
                filtering: false,
                textAlign: "start",
                sortable: true,
                sort: sortDateTime,
                minWidth: 220,
                defaultFlex: 1,
                render: ({ data }) => (
                    <span style={{ marginLeft: "-12px" }}>{data.timestamp}</span>
                ),
            },
            {
                name: "categoryDataForSorting",
                header: "Method",
                visible: true,
                type: "string",
                filtering: false,
                minWidth: 120,
                defaultFlex: 1,
                textAlign: "start",
                sortable: true,
                render: ({ data }) => (
                    <span style={{ display: "flex", marginLeft: "-15px", alignItems: "center" }} >
                        {data?.paymentMethodTypeLocale && (
                            <img
                                src={upiIntentLogoDictionary(data?.paymentMethodSubBrand) || data?.paymentMethodLogoUrl}
                                style={{
                                    height: "28px",
                                    width: "28px",
                                    objectFit: "contain",
                                    marginRight: "8px",
                                    mixBlendMode: "multiply",
                                }}
                            />
                        )}
                        {data?.paymentMethodTypeLocale === "Buy Now Pay Later"
                            ? "BNPL"
                            : data?.paymentMethodTypeLocale}
                    </span>
                ),
                sort: sortPaymentCategory,
            },
            {
                name: "refundAmount",
                header: "Refund Amount",
                visible: true,
                type: "number",
                filtering: false,
                minWidth: 150,
                defaultFlex: 1,
                textAlign: "start",
                sortable: false,
                render: ({ data }) => (
                    <span style={{ display: "flex", marginLeft: "-12px" }}>
                        {`${data?.currencyCode} ${data?.amountLocaleFull}`}
                    </span>
                ),
            },
            {
                name: "reviewWorkflowStatus",
                header: "Status",
                visible: true,
                type: "string",
                filtering: false,
                minWidth: 180,
                defaultFlex: 1,
                textAlign: "start",
                sortable: false,
                render: ({ value }) => {
                    let backgroundColor;
                    let color;
                    let uValue = value?.status?.toUpperCase();
                    if (uValue === "REVIEWED") {
                        backgroundColor = "#D5FBD2";
                        color = "#0B6A48";
                        uValue = "Review Approved"
                    } else {
                        backgroundColor = "#FDE3D6";
                        color = "#B9232F";
                        uValue = "Review Declined"
                    }
                    return (
                        <span
                            style={{
                                marginLeft: "-20px",
                                paddingBottom: "6px",
                                paddingRight: "8px",
                                paddingLeft: "8px",
                                paddingTop: "5px",
                                borderRadius: "8px",
                                backgroundColor,
                                color,
                                textTransform: "uppercase",
                            }}
                        >
                            {uValue}
                        </span>
                    );
                },
            },
        ],
    }
}
